<!-- main app container -->

@if (auth.loggedIn()) {
  <div>
    @if (showContent) {
      <router-outlet></router-outlet>
    } @else {
      <div class="app-loading-screen">
        <div class="app-loading-content">
          <img src="assets/logos/logo-corto.png" alt="Inprovider" class="app-loading-logo" onerror="this.style.display='none'">
          <div class="app-loading-spinner"></div>
          <p class="app-loading-text">Cargando...</p>
        </div>
      </div>
    }
  </div>
} @else {
  @if (showContent) {
    <router-outlet></router-outlet>
  } @else {
    <div class="app-loading-screen">
      <div class="app-loading-content">
        <img src="assets/logos/logo-corto.png" alt="Inprovider" class="app-loading-logo" onerror="this.style.display='none'">
        <div class="app-loading-spinner"></div>
      </div>
    </div>
  }
}

